//This file is automatically rebuilt by the Cesium build process.
export default "struct czm_modelVertexOutput {\n\
vec3 positionMC;\n\
float pointSize;\n\
};\n\
";
